// Request never completed: no reply to read
const STATUSLESS_ERROR_CODES = [
  'ERR_NETWORK',
  'ECONNABORTED',
  'ECONNREFUSED',
  'ETIMEDOUT',
]

// The XHR's 0 is below any real status
const LOWEST_HTTP_STATUS = 100

// 0.27.2 parks the XHR in .response; trust the code
export const isStatuslessAxiosError = (error: unknown): boolean =>
  typeof error === 'object' &&
  error !== null &&
  'code' in error &&
  typeof error.code === 'string' &&
  STATUSLESS_ERROR_CODES.includes(error.code)

const readStatus = (source: unknown): number | undefined =>
  typeof source === 'object' &&
  source !== null &&
  'status' in source &&
  typeof source.status === 'number' &&
  source.status >= LOWEST_HTTP_STATUS
    ? source.status
    : undefined

// Undefined, never 0, when no reply arrived
export const getResponseStatus = (error: unknown): number | undefined => {
  if (isStatuslessAxiosError(error)) return undefined
  if (typeof error !== 'object' || error === null) return undefined
  if ('response' in error) return readStatus(error.response) ?? readStatus(error)
  return readStatus(error)
}

